// ===============================
// API Configuration
// ===============================

// خليها نفس الدومين علشان nginx + cookies + CORS
const API_BASE_URL = "https://toutsroutes.com"

// ===============================
// Helper: get admin token
// ===============================
const getToken = () => {
  return localStorage.getItem("admin_token")
}

// ===============================
// Generic API helpers
// ===============================
export const apiGet = async (url) => {
  const token = getToken()

  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    credentials: "include"
  })

  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.message || "Request failed")
  }

  return res.json()
}

export const apiPost = async (url, body = {}) => {
  const token = getToken()

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    credentials: "include",
    body: JSON.stringify(body)
  })

  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.message || "Request failed")
  }

  return res.json()
}

export const apiPut = async (url, body = {}) => {
  const token = getToken()

  const res = await fetch(url, {
    method: "PUT",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    credentials: "include",
    body: JSON.stringify(body)
  })

  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.message || "Request failed")
  }

  return res.json()
}

export const apiDelete = async (url) => {
  const token = getToken()

  const res = await fetch(url, {
    method: "DELETE",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    credentials: "include"
  })

  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.message || "Request failed")
  }

  return res.json()
}

// ===============================
// API Endpoints
// ===============================
export const API_ENDPOINTS = {
  // Admin
  ADMIN_LOGIN: `${API_BASE_URL}/api/login`,

  // Dashboard
  DASHBOARD_OVERVIEW: `${API_BASE_URL}/api/overview`,
  DASHBOARD_RECENT_ACTIVITY: `${API_BASE_URL}/api/recent-activity`,
  DASHBOARD_BOOKINGS_TREND: `${API_BASE_URL}/api/charts/bookings-trend`,
  DASHBOARD_REVENUE_TREND: `${API_BASE_URL}/api/charts/revenue-trend`,
  DASHBOARD_OPERATIONS_SUMMARY: `${API_BASE_URL}/api/operations/summary`,

  // Captains
  CAPTAINS: `${API_BASE_URL}/api/captains`,
  CAPTAIN_APPROVE: (id) => `${API_BASE_URL}/api/captains/${id}/approve`,
  CAPTAIN_REJECT: (id) => `${API_BASE_URL}/api/captains/${id}/reject`,
  CAPTAIN_STATUS: (id) => `${API_BASE_URL}/api/captains/${id}/status`,
  CAPTAIN_DEACTIVATE: (id) =>
  `${API_BASE_URL}/api/captains/${id}/deactivate`,
  CAPTAIN_ADMIN_SETTINGS: (id) => `${API_BASE_URL}/api/captains/${id}/admin-settings`,



  // Users
  USERS: `${API_BASE_URL}/api/users`,
  USER_STATUS: (id) => `${API_BASE_URL}/api/users/${id}/status`,
  USER_GOVERNORATE: (id) => `${API_BASE_URL}/api/users/${id}/governorate`,

  // Bookings
  BOOKINGS: `${API_BASE_URL}/api/bookings`,
  BOOKING_SUPPORT: (id) => `${API_BASE_URL}/api/admin/booking-support/${id}`,
  BOOKING_SUPPORT_NOTES: (id) => `${API_BASE_URL}/api/admin/booking-support/${id}/notes`,

  // Financials
  FINANCIALS_OVERVIEW: `${API_BASE_URL}/api/financials/overview`,
  FINANCIALS_DAILY_REVENUE: `${API_BASE_URL}/api/financials/daily-revenue`,
  FINANCIALS_COMMISSIONS: `${API_BASE_URL}/api/financials/commissions`,

  // Notifications
  ADMIN_SEND_NOTIFICATION: `${API_BASE_URL}/api/admin/notifications/send`,
  ADMIN_NOTIFICATION_HISTORY: `${API_BASE_URL}/api/admin/notifications/history`,
  ADMIN_NOTIFICATION_MONITOR: `${API_BASE_URL}/api/admin/notifications/monitor`,
  ADMIN_NOTIFICATION_RETRY: (id) => `${API_BASE_URL}/api/admin/notifications/${id}/retry`,

  // Receipts
  ADMIN_RECEIPTS: `${API_BASE_URL}/api/admin/receipts`,
  ADMIN_RECEIPT_RETRY: (id) => `${API_BASE_URL}/api/admin/receipts/${id}/retry`,

  // Operations
  OPERATIONS_EXCEPTIONS: `${API_BASE_URL}/api/operations/exceptions`,
  OPERATIONS_RISK: `${API_BASE_URL}/api/operations/risk`,

  // Incident response
  ADMIN_INCIDENTS: `${API_BASE_URL}/api/admin/incidents`,
  ADMIN_INCIDENT: (id) => `${API_BASE_URL}/api/admin/incidents/${id}`,

  // Audit
  ADMIN_AUDIT_LOG: `${API_BASE_URL}/api/admin/audit-log`,

  // Captain pricing
  ADMIN_CAPTAIN_PRICING: `${API_BASE_URL}/api/admin/captain-pricing`
}

export default API_BASE_URL
